import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'app/store';
import { AirportsInterface, PubliceState, publicTiers } from './publicData.interface';

const initialState: PubliceState = {
  publicTiers: {
    data: null,
    meta: null,
    error: null,
    loading: true,
  },
  departureLocationsRoute: {
    data: null,
    meta: null,
    error: null,
    loading: true,
  },
};

export const publicDataSlice = createSlice({
  name: 'PublicData',
  initialState,
  reducers: {
    setPublicTiersData: (state, action: PayloadAction<publicTiers[]>) => {
      state.publicTiers.data = action.payload;
      state.publicTiers.loading = false;
      state.publicTiers.error = null;
    },
    setPublicTiersDataLoading(state) {
      state.publicTiers.loading = true;
    },

    setPublicTiersDataError(state, action: PayloadAction<any>) {
      state.publicTiers.data = null;
      state.publicTiers.loading = false;
      state.publicTiers.error = action.payload;
    },

    setDepartureLocationsRoute: (state, action: PayloadAction<AirportsInterface[]>) => {
      state.departureLocationsRoute.data = action.payload;
      state.departureLocationsRoute.loading = false;
      state.departureLocationsRoute.error = null;
    },

    setDepartureLoading(state) {
      state.departureLocationsRoute.loading = true;
    },

    setDepartureError(state, action: PayloadAction<any>) {
      state.departureLocationsRoute.data = null;
      state.departureLocationsRoute.loading = false;
      state.departureLocationsRoute.error = action.payload;
    },
  },
});

export const {
  setPublicTiersData,
  setPublicTiersDataLoading,
  setPublicTiersDataError,
  setDepartureLocationsRoute,
  setDepartureLoading,
  setDepartureError,
} = publicDataSlice.actions;

export const publicTiersState = (state: RootState) => state.publicData.publicTiers;
export const departureLocationsRouteState = (state: RootState) => state.publicData.departureLocationsRoute;

export default publicDataSlice.reducer;
